<template>
    <Mz-Dialog class="dialog" :title="title" width="3147px" :visible.sync="visible" @handleClose="handleClose">
        <div slot="content" class="main" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0,0,0,0)">
            <div class="map" id="distanceMap"></div>
        </div>
    </Mz-Dialog>
</template>

<script>
import echarts from 'echarts'
import 'echarts/map/js/china'
    export default {
        components: {},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            data: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                loading: false
            }
        },
        created() {
        },
        mounted() {
            this.$nextTick(() => {
                this.echartsMap()
            })
        },
        methods: {
            echartsMap(){
                var that = this
                // 散点图数据
                var data =  [...this.data.to,this.data.from]
                var LineData = []
                this.data.to.forEach(it => {
                    LineData.push({
                        fromName: this.data.from.name,
                        toName: it.name,
                        coords: [this.data.from.value, it.value],
                        value: it.value
                    })
                })

                var map = echarts.init(document.getElementById('distanceMap'));
                let option = {
                    grid: {
                        left: 0,   // 左侧距离
                        right: 0,  // 右侧距离
                        top: 0,   // 可选：顶部距离
                        bottom: 0, // 可选：底部距离
                    },
                    //地图
                    geo: {
                        type: 'map',
                        map: 'china',
                        width: '100%',
                        height: '100%',
                        top: 0,
                        roam: false,
                        label: {
                            normal: {
                                show: true, //省份名展示
                                color: '#ffffff',
                                fontSize: 36
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    color: '#ffffff',
                                    fontSize: 36
                                },
                            },
                        },
                        itemStyle: {
                            normal: {
                                areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                                    {offset: 0, color: '#387FE9'},
                                    {offset: 1, color: '#225FBA'}
                                ]),
                                borderWidth: 3,
                                borderColor: '#42AAFF',
                                // shadowColor: '#0345A1',
                                // shadowOffsetX: 0,
                                // shadowOffsetY: 10,
                            },
                            emphasis: {
                                areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                                    {offset: 0, color: '#F9B841'},
                                    {offset: 1, color: '#FF6524'}
                                ]),
                                borderWidth: 3,
                                borderColor: '#FFD942',
                            },
                        },
                    },
                    series: [
                        // 区域散点图
                        {
                            type: 'effectScatter',
                            coordinateSystem: 'geo',
                            zlevel: 2,
                            symbolSize: 20,
                            rippleEffect: { //坐标点动画
                                period: 3,
                                scale: 5,
                                brushType: 'fill'
                            },
                            data: data,
                            itemStyle: { //坐标点颜色
                                normal: {
                                    show: true,
                                    color: '#31FFFF',
                                    shadowBlur: 20,
                                    shadowColor: '#fff'
                                },
                                emphasis: {
                                    areaColor: '#f00'
                                }
                            },

                        },
                        //飞线图
                        {
                            type: 'lines',
                            zlevel: 2,
                            effect: {
                                show: true,
                                //飞机的速度  这里是s单位
                                period: 6,
                                trailLength: 0,
                                symbol: 'circle',//这是圆点替换了飞机
                                // 飞机大小
                                symbolSize: 20,
                                color:'#31FFFF',
                            },
                            lineStyle: {
                                normal: {
                                    color:'#fff',
                                    type:'solid', // 虚线
                                    // 线条宽度
                                    width: 3,
                                    opacity: 1,
                                    curveness: 0.2, // 弯曲度
                                },
                                emphasis: {
                                    color: '#FF9600' //飞线悬浮颜色
                                }
                            },
                            label: {
                                normal: {
                                    show: false,
                                    position: 'middle',
                                    formatter: '{b}'
                                }
                            },
                            data: LineData
                        }
                    
                    ],
                };
                // 设置配置项
                map.setOption(option);
            },
            handleClose(){
                this.$emit('update:visible', false)
            }
        }
    }
</script>

<style lang="less" scoped>
@import '@/styles/common';
.main{
    padding: 40px 300px;
}
.map{
    width: 100%;
    height: 1683px;
}
</style>